// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1y2BV","left":"StickyBox_left__5iUwC","right":"StickyBox_right__B-Rmn"};